import { ChartWidgetDataService } from '@/modules/ta/legacy/widget/services/data/ChartWidgetDataService';

export class FunnelChartDataService extends ChartWidgetDataService {}
